import checkout from "./form";

const {
  formField: { checkbox1, checkbox2, organizeName, taxId, timeSign, signer },
} = checkout;

const initialValues = {
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [organizeName.name]: "",
  [taxId.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
